import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import PromotionsPage from 'modules/restaurant/promotions/PromotionsPage';

export default function DashRestaurantPromotions() {
    return (
        <DashEstablishmentContainer title='Promoções'>
            <PromotionsPage />
        </DashEstablishmentContainer>
    );
}
